import styled from 'styled-components';
import {color, ColorProps} from "styled-system";
import {LoaderContainer} from "../../ui/Loader/MiniLoader";
import {WindowSizePXEnum} from "../../interface/Basic/window";

export const Button = styled.button`
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  padding: 18px 24px;
  text-align: center;
  box-shadow: none !important;
  margin: 0;
  border-radius: 4px;
  border-bottom-width: 0;
  border-style: solid;
  border-color: transparent;
  user-select: none;

  :disabled {
    background: rgba(0, 122, 255, 0.5);
    cursor: not-allowed;
  }
`;

export const ButtonPrimary = styled(Button)`
  background-color: ${({theme}) => theme.color.indicator};
  color: ${({theme}) => theme.color.primaryBackground};
`;

export const ButtonDefault = styled(Button)`
  background-color: ${({theme}) => theme.color.primaryBackground};
  color: ${({theme}) => theme.color.indicator};
`;

export const ButtonDefaultLeft = styled(ButtonDefault)`
  margin-right: auto;
  padding-left: 0;
`;

export const ButtonRow = styled.div`
  display: flex;
  padding: 12px 24px;
  justify-content: flex-end;
`

export const ModalBtn = styled.div`
  padding: 8px 12px;
  width: fit-content;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
position: relative;
  svg {
    margin: 0 12px;
  }

  ${LoaderContainer} {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 20px;
    height: 20px;
  }
  ${color}
`
export const ModalBtnText = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.2px;
  ${color}
`

export const ModalDefaultBtn = styled(ModalBtn)<ColorProps>`
  align-items: center;
  gap: 10px;
  color: ${({theme}) => theme.color.indicator};

  :hover {
    background: ${({theme}) => theme.color.secondaryBackground}
  }

  svg {
    margin: 0;
  }

  ${color}
`

export const ModalActiveBtn = styled(ModalBtn)<ColorProps>`
  background-color: ${({theme}) => theme.color.indicator};
  color: ${({theme}) => theme.color.primaryBackground};
justify-content: center;
  :hover {
    box-shadow: inset 0 0 100px 100px rgba(255, 255, 255, 0.2);
  }
`

export const WarningModalActiveBtn = styled(ModalActiveBtn)`
  width: 67px;
  justify-content: center;
`

export const ExAccInfoModalOKBtn = styled(ModalActiveBtn)`
  width: 160px;
  justify-content: center;
`

export const ExAccInfoModalContent = styled.div`
  display: flex;
  padding: 6px 24px;
  margin-bottom: -12px;
  justify-content: center;
  text-align: center;
`

export const ModalDisabledBtn = styled(ModalActiveBtn)<ColorProps>`
  cursor: not-allowed;
  filter: opacity(40%);
  pointer-events: none;

  :hover {
    filter: opacity(40%);
    background: none;
  }

  ${color}
`

export const ModalButtonSecondary = styled(ModalBtn)`
  background-color: rgba(0, 87, 230, 0.08);
  color: #007AFF;

  svg {
    margin: auto 7px 0 0;
    color: #007AFF;
  }
`;

export const ModalDangerBtn = styled(ModalBtn)<ColorProps>`
  background-color: rgba(255, 51, 71, 0.08);
  color: #FF3347;
`
export const VerifyButton = styled(Button)`
  background: #E1E7ED;
  min-width: 222px;
  height: 40px;
  padding: 0 16px;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    height: 56px;
  }
`
export const SubmitModalButton = styled(ButtonPrimary)`
  margin-top: 24px;
  width: 100%;
`
export const FindUserDefaultBtn = styled(ButtonDefault)`
  margin-top: 0 !important;
  font-weight: 400;
  padding-top: 11px;
  height: 59px;
`

export const SynchronizationButton = styled.button`
  padding: 10px 24px;
  width: 202px;
  height: 40px;
  background: #EBF4FF;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  :hover{
    background-color:#d4e8ff;
  }
  :disabled{
    cursor: not-allowed;
    pointer-events: none;
  }
  :active{
    background-color:#EBF4FF;
  }
`
